import { logout } from "@/pages/login/authSlice";
import { apiSlice } from "@/api";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { adminServiceApiSlice } from "@/api/adminServiceApi";

const useLogout = () => {
 const dispatch = useDispatch();
 const navigate = useNavigate()

 return () => {
   dispatch(logout())
   dispatch(apiSlice.util.resetApiState())
   dispatch(adminServiceApiSlice.util.resetApiState())
   navigate('/login', { replace: true, state: null })
 }
}
export default useLogout;